import SRS from '../../../services/StudentRecordService';

export async function fetchReport(classId, student, selectedPercentiles, locale) {
  let studentId = null
  if (student) studentId = student.value

  const useARM = selectedPercentiles && selectedPercentiles.state !== "US";
  const data = await SRS.getReadingRopeData({ classId, studentId, useARM, locale });
  return data.readingRopeReport;
}